import { usePermissions } from "../../../../../../../server/auth/use-permissions";
import { useFlag } from "../../../../../../../server/optimizely";

/** Whether the preview on screen is a reviewer's, served by the reviewer schema. */
export function useReviewerPreview(): boolean {
  const { reviewer } = usePermissions();
  const [reviewExperienceEnabled] = useFlag("reviewer_role");

  return reviewExperienceEnabled && reviewer;
}
